export default __webpack_public_path__ + "static/media/water-7.9668d174.png";